export class LanguagePageItem {
  idLanguagePageItem: number;
  idLanguagePage: number;
  code: string;
  orphan: boolean;

  constructor(
    idLanguagePageItem: number,
    idLanguagePage: number,
    code: string,
    orphan: boolean,
  ) {
    this.idLanguagePageItem = idLanguagePageItem;
    this.idLanguagePage = idLanguagePage;
    this.code = code;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): LanguagePageItem {
    return new LanguagePageItem(
      Number(raw.idLanguagePageItem),
      Number(raw.idLanguagePage),
      String(raw.code),
      Boolean(raw.orphan),
    );
  }

  clone(): LanguagePageItem {
    return new LanguagePageItem(
      this.idLanguagePageItem,
      this.idLanguagePage,
      this.code,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idLanguagePageItem: this.idLanguagePageItem,
      idLanguagePage: this.idLanguagePage,
      code: this.code,
      orphan: this.orphan,
    };
  }
}
